import OpticalGymBaseClass from "./opticalgym_base_class";
import { Uuid } from "./uuid";

export default class UserMetadata extends OpticalGymBaseClass {
    id: string | null;
    data: any;
    user_id: Uuid | null;
    clinic_id: Uuid | null;
    category: string;

    static fromJson(data: Object): UserMetadata {
        let user_metadata = new UserMetadata();
        Object.assign(user_metadata, data);
        return user_metadata;
    }
}

